'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _analyticsContext = require('./analytics-context');

var _analyticsContext2 = _interopRequireDefault(_analyticsContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Props) {
    return function (WrappedComponent) {
        return function (_Component) {
            (0, _inherits3.default)(WithAnalyticsContext, _Component);

            function WithAnalyticsContext() {
                (0, _classCallCheck3.default)(this, WithAnalyticsContext);
                return (0, _possibleConstructorReturn3.default)(this, (WithAnalyticsContext.__proto__ || (0, _getPrototypeOf2.default)(WithAnalyticsContext)).apply(this, arguments));
            }

            (0, _createClass3.default)(WithAnalyticsContext, [{
                key: 'render',
                value: function render() {
                    return _react2.default.createElement(
                        _analyticsContext2.default,
                        Props,
                        _react2.default.createElement(WrappedComponent, this.props)
                    );
                }
            }]);
            return WithAnalyticsContext;
        }(_react.Component);
    };
};